// extracted by mini-css-extract-plugin
export default {"food":"index_food_5xmo1"};